import { render, staticRenderFns } from "./topOrder.vue?vue&type=template&id=3ddebf97&scoped=true&"
import script from "./topOrder.vue?vue&type=script&lang=js&"
export * from "./topOrder.vue?vue&type=script&lang=js&"
import style0 from "./topOrder.vue?vue&type=style&index=0&id=3ddebf97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddebf97",
  null
  
)

export default component.exports